export default "__VITE_ASSET__09bc064d__"